const draftKey = (propertyId) => `bfp_stay_booking_draft_${propertyId || 'unknown'}`;

function reviveDates(dates) {
  if (!dates || typeof dates !== 'object') return dates;
  const next = { ...dates };
  if (next.checkInDate && !(next.checkInDate instanceof Date)) {
    const d = new Date(next.checkInDate);
    if (!Number.isNaN(d.getTime())) next.checkInDate = d;
  }
  if (next.checkOutDate && !(next.checkOutDate instanceof Date)) {
    const d = new Date(next.checkOutDate);
    if (!Number.isNaN(d.getTime())) next.checkOutDate = d;
  }
  return next;
}

export function saveStayBookingDraft(propertyId, bookingData) {
  if (!propertyId || !bookingData) return;
  try {
    const payload = {
      ...bookingData,
      dates: bookingData.dates
        ? {
            ...bookingData.dates,
            checkInDate:
              bookingData.dates.checkInDate instanceof Date
                ? bookingData.dates.checkInDate.toISOString()
                : bookingData.dates.checkInDate,
            checkOutDate:
              bookingData.dates.checkOutDate instanceof Date
                ? bookingData.dates.checkOutDate.toISOString()
                : bookingData.dates.checkOutDate
          }
        : bookingData.dates
    };
    sessionStorage.setItem(draftKey(propertyId), JSON.stringify(payload));
  } catch (e) {
    console.warn('Could not persist stay booking draft:', e);
  }
}

export function loadStayBookingDraft(propertyId) {
  if (!propertyId) return null;
  try {
    const raw = sessionStorage.getItem(draftKey(propertyId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.dates) {
      parsed.dates = reviveDates(parsed.dates);
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearStayBookingDraft(propertyId) {
  if (!propertyId) return;
  try {
    sessionStorage.removeItem(draftKey(propertyId));
  } catch {
    /* ignore */
  }
}
